import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
import $ from "jquery";
import {
  getAxiosResponse,
  postAxiosResponse,
  postAxiosFormDataResponse,
} from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import DatePickerCalendar from "../../dashboard/calendars/DatePickerCalendar";
import { useSelector, useDispatch } from "react-redux";
import { dateFormat, timeStamp } from "../../../services/Util";
import Constants from "../../../Constants";
import { transformBlankToNull,addDaysToDate } from "../../../services/Util";
import CustomProgressBar from "../../global/CustomProgressBar";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import dateUtil from "../../../services/DateUtil";
import store from "../../../redux/store";
import DateFormat from "../../../pages/DateFormat";
const chunkSize = Constants.CHUNK_SIZE;

export default function CustomTaskForm(prop) {
  const { t } = useTranslation();
  const translate = t;
  const [toggle, toggleCal] = useState(false);
  const [toggle1, toggleCal1] = useState(false);
  const refToggle = useRef(null);
  const refToggle1 = useRef(null);
  const refCalendar = useRef(null);
  const refCalendar1 = useRef(null);
  const workspaceId = prop.id;
  const inputRef = useRef(null);
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const [taskName, setTaskName] = useState("");
  const [taskDescription, setTaskDescription] = useState("");
  const [selectedAssignedUser, setSelectedAssignedUser] = useState("");
  const [selectedNotifyUser, setSelectedNotifyUser] = useState("");
  const [showNotificationUsers, setShowUsers] = useState([]);
  const [users, setUsers] = useState([]);
  const [validation,setValidation] = useState(true);
  const [notifyUsers, setNotifyUsers] = useState([]);
  const [languageFilter, setLanguageFilter] = useState([]);
  const [selectedLanguages, setLanguage] = useState("");
  const [selectedfile, setSelectedFile] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [allUsers, setAllUsers] = useState([]);
  const [reminderDay, setReminderDay] = useState("");
  const [allowReminder, setAllowReminder] = useState(false);
  const [currentChunkIndex, setCurrentChunkIndex] = useState(null);
  const [documentFileId, setDocumentFileId] = useState(-1);
  const [hasDocument, setHasDocument] = useState(true);
  const [fileUploadProgress, setFileUploadProgress] = useState(0);
  const [showProgress,setShowProgress] = useState(false);
  const customerRedux = store.getState()?.customer_bootstrap_data?.value;
  const customerTimeZone = customerRedux?.user?.timeZone;
  const dayFormat =  customerRedux?.dateFormatInDays?.toUpperCase();

  const checkValidation = (event) => {
    if(taskName === '' || selectedAssignedUser === ''){
      setValidation(false)
    }
    else{
      setValidation(true)
    }
    
  };
  
  
  
  const showCalendarStartDate = (event) => {
    toggle ? toggleCal(false) : toggleCal(true);
    $('#calFirstFocus').toggleClass('calFirstFocus')
    $('.calFirstFocus').trigger('focus')
    $(document).mouseup(function(e) {
      var bannerCont = $('.firstCal');
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        toggleCal(false)
        $('#calFirstFocus').removeClass('calFirstFocus')
     }
    });
    if (toggle) {
      var requiredElement = document.querySelector(".dashCalendar");
      requiredElement.focus();
    }
  };
$("#calFirstFocus").on("keydown", function (e) {
  if (e.key === Constants.ESCAPE) {
    if($('div').hasClass('dashCalendar')){
      toggleCal(false)
      $('.calFirstFocus').trigger('focus')
      $('#calFirstFocus').removeClass('calFirstFocus')
      }
    }
    if (e.key === Constants.TAB && e.shiftKey) {
    if($('div').hasClass('dashCalendar')){
      toggleCal(false)
      $('.calFirstFocus').trigger('focus')
      $('#calFirstFocus').removeClass('calFirstFocus')
      }
    }
  });
const handleEscFocus = (event) => {
  if (event.key === Constants.ESCAPE) {
    toggleCal(false)
      $('.calFirstFocus').trigger('focus')
      $('#calFirstFocus').removeClass('calFirstFocus')
  }
}
const showCalendarDueDate = (event) => {
  toggle1 ? toggleCal1(false) : toggleCal1(true);
  $('#calSecondFocus').toggleClass('calSecondFocus')
  $('.calSecondFocus').trigger('focus')
  $(document).mouseup(function(e) {
    var bannerCont = $('.caltopset');
    if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
      toggleCal1(false)
      $('#calSecondFocus').removeClass('calSecondFocus')
   }
   });
  if (toggle1) {
    var requiredElement = document.querySelector(".dashCalendar1");
    requiredElement.focus();
  }
};
$("#calSecondFocus").on("keydown", function (e) {
  if (e.key === Constants.ESCAPE) {
    if($('div').hasClass('dashCalendar1')){
      toggleCal1(false)
      $('.calSecondFocus').trigger('focus')
      $('#calSecondFocus').removeClass('calSecondFocus')
     }
   }
   if (e.key === Constants.TAB && e.shiftKey) {
    if($('div').hasClass('dashCalendar1')){
      toggleCal1(false)
      $('.calSecondFocus').trigger('focus')
      $('#calSecondFocus').removeClass('calSecondFocus')
     }
   }
 });
 const handleEscFocus2 = (event) => {
  if (event.key === Constants.ESCAPE && event.target.ariaExpanded === 'true') {
      toggleCal1(false)
      $('.calSecondFocus').trigger('focus')
      $('#calSecondFocus').removeClass('calSecondFocus')
  }
}
const closeCalendar = (e) => {
  if (e.code === "Escape") {
    toggleCal(false);
    $('.calFirstFocus').trigger('focus')
    $('#calFirstFocus').removeClass('calFirstFocus')
  }
};
const closeCalendar2 = (e) => {
  if (e.code === "Escape") {
    toggleCal1(false);
    $('.calSecondFocus').trigger('focus')
      $('#calSecondFocus').removeClass('calSecondFocus')
  }
};  
  const removeItem = (id) => {
    setShowUsers((current) =>
      current.filter(
        (showNotificationUsers) => showNotificationUsers?.resource?.userId !== id
      )
    );
  };
  const setReminder = (e) => {
    setAllowReminder(e.target.checked);
    if (e.target.checked === false) {
      $("#task-email-reminder-day").val("");
    }
  };
  const handleReminderDay = (event) => {
    var element = $("#emailReminderDay");
    element.val(element.val().replace(/[^0-9\.]/g, ""));
    setReminderDay(event.target.value);
  };
  useEffect(() => {
    inputRef.current.focus();
    const languageArray = [];
    getAxiosResponse(APIUrls.CAMPAIGN_LANGUAGE_FILTER_VALUES(workspaceId))
      .then((res) => {
        if (res.data !== "") {
          res.data.data.map((language) => {
            languageArray.push({
              label: language.display,
              value: language.display,
            });
          });
        }
        var languages = [
          {
            value: "",
            label: "Select Language",
          },
          ...languageArray,
        ];
        setLanguageFilter(languages);
      })
      .catch((err) => {
        handleError(err);
      });
    getAxiosResponse(APIUrls.CAMPAIGN_MEMBER_USER(workspaceId))
      .then((res) => {
        if (res.data.code === 200) {
          var users = res.data.data;
          setAllUsers(users);
          var options = users.map(({ resource, displayName }) => ({
            key: resource?.userId,
            label:
              resource?.firstName +
              " " +
              resource?.lastName +
              " (" +
              displayName[0][0] +
              ")",
            value: resource?.userId,
          }));
         
         
          setUsers(options);

          var followers = [
            {
              key: "0",
              value: "all-follower",
              label: "Select All Project Followers",
            },
            ...options,
          ];
          setNotifyUsers(followers);
        }
      })
      .catch((err) => {
        handleError.log(err);
      });
  }, []);

  const handleAssignedUserChange = (event) => {
    setSelectedAssignedUser(event.value);
  };
  const handleNotifyUserChange = (event) => {
    var selectedId = event.value;
    if (event.value === "all-follower") {
      setShowUsers(allUsers);
    } else {
      var result = [];
      result[0] = allUsers.find(
        ({ resource }) => resource?.userId == selectedId
      );
      setShowUsers(result);
    }
    setSelectedNotifyUser(event.value);
  };
  const handleLanguageChange = (event) => {
    var selectedLang = event.value;
    setLanguage(selectedLang);
  };
  const selectStartDate = (event) => {
    setDueDate("");
    setStartDate(event);
    refToggle.current.focus();
      toggleCal(false);
      $('.calFirstFocus').trigger('focus')
      $('#calFirstFocus').removeClass('calFirstFocus')
  };
  const selectDueDate = (event) => {
    setDueDate(event);
    refToggle1.current.focus();
    toggleCal1(false);
    $('.calSecondFocus').trigger('focus')
    $('#calSecondFocus').removeClass('calSecondFocus')
  };
  function fileSelection(e) {
    if (e?.target?.files[0]) {
      setSelectedFile(e.target.files[0]);
    }
  }
  const createTask = () => {
    checkValidation()
    let taskData = {
      type: "custom",
      displayName: taskName,
      description: taskDescription,
      currentAssignee: selectedAssignedUser,
      targetLanguage: selectedLanguages,
      startDate:  timeStamp(startDate,customerTimeZone),
      dueDate:  timeStamp(dueDate,customerTimeZone),
      // "emailReminderDay": reminderDay,
      hasDocument: "false",
      project: null,
      workspace: {},
    };
    if (allowReminder) {
      // data.sendEmailReminder = "on"
      taskData.emailReminderDay = reminderDay;
    } else {
      taskData.emailReminderDay = null;
    }
    if (selectedfile !== "") {
      taskData.hasDocument = "true";
    } else {
      taskData.hasDocument = "false";
    }
  
    if(taskName !== '' && selectedAssignedUser !== '' ){
      setHasDocument(taskData.hasDocument);
    taskData = transformBlankToNull(taskData);
    postAxiosResponse(APIUrls.CAMPAIGN_CUSTOM_TASK, taskData)
      .then((res) => {
        if (res.status === 200) {
          let documentFileId = -1;
          if (res?.data?.data?.documentFileId) {
            documentFileId = res?.data?.data?.documentFileId;
            setDocumentFileId(documentFileId);
          }
          if (documentFileId === -1) {
            setCurrentChunkIndex(0);
          } else {
            setShowProgress(true)
            setCurrentChunkIndex(0);
          }
        }
      })
      .catch((err) => {
        handleError(err);
      });
    }
    
    
    
  };
const resetfelds = () =>{
  prop.funct(false)
}
  useEffect(() => {
    if (currentChunkIndex !== null) {
      readAndUploadCurrentChunk();
    }
  }, [currentChunkIndex]);

  function readAndUploadCurrentChunk() {
    const file = selectedfile;
    if (file) {
      const reader = new FileReader();
      const from = currentChunkIndex * chunkSize;
      const to = from + chunkSize;
      const blob = file.slice(from, to);
      reader.onload = (e) => uploadChunk(e);
      reader.readAsDataURL(blob);
    }else{
      uploadChunk(null);
    }
  }

  function getParams(file){
    const params = new URLSearchParams();

    // This line of code creates a new date format string. It takes the first character of the dayFormat string, 
    // repeats it (by concatenating it to the front of the string), and removes all single quote characters ('), 
    // if any exist in the date string.
    let newDateFormat = dayFormat.replace(/'/g, "");

    if (newDateFormat.charAt(0) !== newDateFormat.charAt(1)) {
      newDateFormat = newDateFormat.charAt(0) + newDateFormat;
    }

    if(file){
      params.set("name", file.name);
      params.set("size", file.size);
      params.set("currentChunkIndex", currentChunkIndex);
      params.set("totalChunks", Math.ceil(file.size / chunkSize));
    }
    params.set("displayName", taskName);
    params.set("description", taskDescription);
    params.set("currentAssignee", selectedAssignedUser);
    params.set("targetLanguage", selectedLanguages);
    params.set("workspaceId", workspaceId);
    params.set("hasDocument", hasDocument);
    params.set("emailReminderDay", reminderDay !== "" ? reminderDay : "");
    params.set("sendEmailReminder", "true");
    params.set("customerFollower", selectedAssignedUser);
    //Date will we MM/DD/YY
    params.set("startDate", dateUtil.format(startDate, Constants.DATE_FORMAT_D_M_YYYY, null));
    params.set("dueDate",dateUtil.format(dueDate, Constants.DATE_FORMAT_D_M_YYYY, null));
    params.set("documentFileId", (documentFileId !==-1) ? documentFileId : "");
    return params;
  }

  function uploadChunk(readerEvent) {
    //for testing purpose
    const file = selectedfile;
    const data = readerEvent ? readerEvent.target.result : {};
    const params = getParams(file);
    const headers = {
      "Content-Type": "application/octet-stream",
      "CSRF-Token": localStorage.getItem("csrfToken"),
    };
    const urlPart = file ? APIUrls.UPLOAD_ASSET_ATTACHMENT : APIUrls.UPLOAD_ASSET_ATTACHMENT.replace("/upload","");
    const url =
      `${process.env.REACT_APP_BACKEND_SERVER}${urlPart}?` +
      params.toString();
    axios.post(url, data, { headers }).then((response) => {
      if(selectedfile){
        const filesize = selectedfile.size;
        const chunks = Math.ceil(filesize / chunkSize) - 1;
        const isLastChunk = currentChunkIndex === chunks;
        if (isLastChunk) {
          setCurrentChunkIndex(null);
          setFileUploadProgress(100);
          setTimeout(() => {
            prop.funct(false)
          }, 1000);
        } else {
          const chunks = Math.ceil(filesize / chunkSize);
          setFileUploadProgress(Math.round((currentChunkIndex / chunks) * 100));
          setCurrentChunkIndex(currentChunkIndex + 1);
        }
      }else {
        setCurrentChunkIndex(null);
        //setFileUploadProgress(100);
        setTimeout(() => {
          prop.funct(false)
        }, 1000);
      }
    });
  }
  const formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  };
  const iconComponent = () => {
    return (
      <i className="arrow-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="8"
          viewBox="0 0 12 8"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.21967 0.815454C0.512563 0.519849 0.987437 0.519849 1.28033 0.815454L6 5.57882L10.7197 0.815454C11.0126 0.519849 11.4874 0.519849 11.7803 0.815454C12.0732 1.11106 12.0732 1.59033 11.7803 1.88593L6.53033 7.18455C6.23744 7.48015 5.76256 7.48015 5.46967 7.18455L0.21967 1.88593C-0.0732233 1.59033 -0.0732233 1.11106 0.21967 0.815454Z"
            fill="#076FA3"
          ></path>
        </svg>
      </i>
    );
  };

  return (
    <div className="task-form-content">
      <div className="form-group">
        <div className="form-text">
          <label htmlFor="Task Name">{translate("task_campaign.task_name")}</label>
          <br />
          <input
            type="text"
            id="task_name"
            name="taskName"
            className="form-control-sm"
            title="Task Name"
            ref={inputRef}
            onChange={(event) => setTaskName(event.target.value)}
            required
          />
          {!validation && taskName === ''? (
            <div className="error" aria-label="error alert" role="alert">
              Task name required
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="form-group">
        <div className="form-text">
          <label htmlFor="task-campaign">
            {translate("task_campaign.description")}<span>{translate("task_campaign.optional")}</span>
          </label>
          <textarea
            className="textarea form-control-sm"
            placeholder={translate("task_campaign.characters_limit")}
            maxLength={5000}
            onChange={(event) => setTaskDescription(event.target.value)}
            id="task-campaign"
            
          ></textarea>
        </div>
      </div>
      <div className="form-group">
        <h6 className="subhead-taskform">{translate("task_campaign.select_user")}</h6>
        <div className="flex wrap-dropdown">
          <div className="global-dropdown-block flex-center">
            <label>{translate("task_campaign.assigned_to")}</label>
            <div className="global-dropdown-select">
              <Select
                classNamePrefix="cw"
                className="global-dropdown-select"
                value={users.filter(function (option) {
                  return option.value === selectedAssignedUser;
                })}
                aria-label="Assigned to"
                options={users}
                onChange={(e) => handleAssignedUserChange(e)}
              />
            </div>
            { !validation && selectedAssignedUser === '' ? (
              <div className="error" aria-label="error alert" role="alert">
                Please select a user
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="global-dropdown-block flex-center">
            <label >{translate("task_campaign.who_will_receive_notifications_about_this_task?")}</label>
            <div className="global-dropdown-select">
              <Select
                classNamePrefix="cw"
                className="global-dropdown-select"
                value={notifyUsers.filter(function (option) {
                  return option.value === selectedNotifyUser;
                })}
                aria-label="Who will receive notifications about this task"
                options={notifyUsers}
                onChange={(e) => handleNotifyUserChange(e)}
              />
            </div>
            <div className="multiselect-output flex">
              {showNotificationUsers.map((user, index) => {
                return (
                  <button key={index} onClick={() => removeItem(user?.resource?.userId)}>
                    <strong>
                      {user?.resource?.firstName +
                        " " +
                        user?.resource?.lastName +
                        " (" +
                        user.displayName[0][0] +
                        ")"}
                    </strong>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="9"
                      viewBox="0 0 10 9"
                      fill="none"
                    >
                      <path
                        d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                        stroke="#213248"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="form-group">
        <h6 className="subhead-taskform border-bottom">
          {translate("task_campaign.language_and_attachments")} <span> {translate("task_campaign.optional")}</span>
        </h6>
        <div className="flex wrap-dropdown">
          <div className="flex w-d100">
          <div className="global-dropdown-block flex-center">
            <label>{translate("task_campaign.task_language")}</label>
            <div className="global-dropdown-select">
              <Select
                classNamePrefix="cw"
                className="global-dropdown-select"
                value={languageFilter.filter(function (option) {
                  return option.value === selectedLanguages;
                })}
                aria-label="Task languages"
                options={languageFilter}
                onChange={(e) => handleLanguageChange(e)}
              />
            </div>
          </div>
          <div className="global-dropdown-block flex-center">
            <label>{translate("task_campaign.add_attachment")}</label>

            <div className="file-input flex">
              <div className="input-file mb-0">
                <input type="file" id="files" onChange={fileSelection} />
                <label className="file-button flex-center" htmlFor="files">
                  {!selectedfile ? "Choose file" : "or select to replace"}
                </label>
              </div>
              
            </div>
          </div>
        </div>
        <div
                className={
                  selectedfile
                    ? "uploading-files-block uploading-success max-w524"
                    : "uploading-files-block uploading-success max-w524 hide"
                }
              >
                <div className="uploading-file-list flex">
                  <div className="left-file-desc flex-center">
                    <div className="icon-block">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                      >
                        <path
                          d="M19.3612 24.1735H5.63886C4.72272 24.1723 3.84447 23.8078 3.19673 23.1599C2.54899 22.5121 2.18464 21.6338 2.18359 20.7176V4.28144C2.18481 3.36542 2.54924 2.48727 3.19696 1.83955C3.84469 1.19182 4.72284 0.827397 5.63886 0.826178H14.402C14.8572 0.825314 15.3081 0.914634 15.7286 1.08898C16.1491 1.26333 16.531 1.51925 16.852 1.84197L21.8 6.78539C22.4488 7.43731 22.8141 8.31894 22.8165 9.23868V20.7176C22.8154 21.6338 22.4511 22.5121 21.8034 23.1599C21.1556 23.8078 20.2774 24.1723 19.3612 24.1735ZM5.63886 2.47091C5.15889 2.47161 4.69878 2.66259 4.35939 3.00197C4.02 3.34136 3.82903 3.80147 3.82833 4.28144V20.7176C3.82903 21.1977 4.01998 21.6578 4.35935 21.9973C4.69872 22.3368 5.15883 22.5279 5.63886 22.5288H19.3612C19.8413 22.5279 20.3014 22.3368 20.6407 21.9973C20.9801 21.6578 21.1711 21.1977 21.1717 20.7176V9.2367C21.1706 8.75346 20.9786 8.29024 20.6375 7.94789L15.6895 3.00447C15.5208 2.83483 15.3202 2.70033 15.0992 2.60874C14.8782 2.51716 14.6412 2.47031 14.402 2.47091H5.63886Z"
                          fill="#EA6404"
                        ></path>
                        <path
                          d="M21.2624 9.02539H18.1999C17.2868 9.02452 16.4113 8.66138 15.7656 8.01568C15.1199 7.36998 14.7567 6.49447 14.7559 5.58131V1.65039H16.4006V5.58131C16.4011 6.05837 16.5909 6.51573 16.9282 6.85306C17.2655 7.19039 17.7229 7.38013 18.1999 7.38065H21.2624V9.02539Z"
                          fill="#EA6404"
                        ></path>
                        <path
                          d="M9.09858 16.2195C9.0335 16.2177 8.96983 16.2001 8.91305 16.1682C8.84727 16.134 8.77753 16.0958 8.70319 16.0537L6.1374 14.5458C6.07628 14.5057 6.02717 14.4498 5.99529 14.384C5.96422 14.3214 5.94779 14.2525 5.94727 14.1827C5.94722 14.1102 5.96364 14.0387 5.99529 13.9735C6.02596 13.9088 6.07551 13.8549 6.1374 13.8189L8.70319 12.3432C8.76483 12.3046 8.82978 12.2716 8.89727 12.2445C8.95114 12.2222 9.0087 12.2101 9.067 12.209C9.12446 12.2118 9.18064 12.2269 9.23173 12.2534C9.28281 12.2798 9.32761 12.317 9.36305 12.3623C9.44775 12.4479 9.49708 12.5623 9.50121 12.6827C9.50051 12.737 9.48529 12.7902 9.45713 12.8366C9.42521 12.891 9.37991 12.9363 9.32555 12.9682L6.58608 14.5557L6.53082 13.7662L9.31766 15.4327C9.37448 15.4644 9.42036 15.5125 9.44924 15.5708C9.475 15.6235 9.48849 15.6813 9.48871 15.7399C9.48922 15.8646 9.44217 15.9849 9.35713 16.0761C9.32648 16.1168 9.28762 16.1505 9.24308 16.1752C9.19855 16.2 9.14932 16.215 9.09858 16.2195Z"
                          fill="#EA6404"
                        ></path>
                        <path
                          d="M9.09903 16.3842C9.00676 16.3829 8.91629 16.3585 8.83588 16.3132C8.77009 16.2796 8.69772 16.2401 8.6214 16.1967L6.05232 14.6882C5.96296 14.631 5.89121 14.5502 5.84509 14.4546C5.80286 14.3702 5.78036 14.2773 5.7793 14.1829C5.78005 14.0858 5.80253 13.99 5.84509 13.9026C5.88955 13.8086 5.96161 13.7304 6.05167 13.6783L8.61745 12.2007C8.68592 12.1578 8.75815 12.1212 8.83324 12.0915C8.94371 12.0425 9.06734 12.0318 9.18457 12.061C9.30181 12.0902 9.40598 12.1576 9.48061 12.2526C9.5932 12.368 9.65785 12.5218 9.66153 12.6829C9.6609 12.7661 9.6382 12.8476 9.59574 12.9191C9.55045 12.9955 9.48693 13.0594 9.41088 13.1053L7.55496 14.1836L9.40759 15.2888C9.4929 15.3369 9.5617 15.4096 9.60496 15.4974C9.64142 15.5722 9.66053 15.6543 9.66088 15.7375C9.66142 15.9022 9.60014 16.0612 9.48917 16.1829C9.44246 16.2426 9.38342 16.2914 9.31609 16.3262C9.24876 16.3609 9.17472 16.3807 9.09903 16.3842ZM6.69443 14.6823L8.78719 15.9119C8.85759 15.9526 8.92469 15.9888 8.98917 16.0224C9.03118 16.0446 9.07979 16.0509 9.12608 16.0401C9.17237 16.0294 9.21322 16.0023 9.24114 15.9638C9.29873 15.9027 9.33033 15.8215 9.3293 15.7375C9.32891 15.7033 9.32081 15.6695 9.30561 15.6388C9.28959 15.6106 9.26555 15.5877 9.23653 15.573L7.22995 14.3724L6.69443 14.6823ZM6.37535 13.873L6.22009 13.9619C6.18718 13.9813 6.16083 14.0102 6.14443 14.0448C6.12361 14.0878 6.11282 14.1351 6.11285 14.1829C6.11324 14.2286 6.12404 14.2736 6.14443 14.3145C6.16336 14.3542 6.19297 14.388 6.22996 14.4119L6.4214 14.5237L6.37535 13.873ZM6.71877 14.0665L6.7339 14.2796L6.90627 14.179L6.71877 14.0665ZM6.71153 13.6796L7.23259 13.9901L9.24509 12.8244C9.27393 12.8073 9.29811 12.7833 9.31548 12.7546C9.32897 12.7331 9.33647 12.7083 9.33719 12.6829C9.33269 12.6032 9.29813 12.5282 9.24048 12.473C9.15166 12.3737 9.08785 12.3737 9.06745 12.3737C9.02994 12.3751 8.99297 12.3831 8.95824 12.3974C8.90003 12.4214 8.84391 12.4502 8.79048 12.4836L6.71153 13.6796Z"
                          fill="#EA6404"
                        ></path>
                        <path
                          d="M10.9549 17.2788C10.8531 17.2738 10.7558 17.2349 10.6786 17.1682C10.634 17.1357 10.5978 17.0928 10.5732 17.0434C10.5486 16.9939 10.5362 16.9393 10.5372 16.884C10.5379 16.8181 10.5539 16.7533 10.5839 16.6946L13.7891 10.1321C13.8233 10.062 13.8753 10.0021 13.9398 9.95837C13.9974 9.91694 14.0662 9.894 14.1372 9.89258C14.2372 9.89676 14.3329 9.93454 14.4089 9.99982C14.4536 10.033 14.4896 10.0766 14.5137 10.1268C14.5377 10.177 14.5492 10.2323 14.547 10.288C14.5462 10.3539 14.5302 10.4187 14.5003 10.4774L11.3029 17.0399C11.2695 17.1091 11.2193 17.1688 11.1569 17.2136C11.0981 17.256 11.0274 17.2788 10.9549 17.2788Z"
                          fill="#EA6404"
                        ></path>
                        <path
                          d="M10.9533 17.4419C10.8154 17.4371 10.6829 17.3864 10.577 17.2978C10.5125 17.2496 10.4603 17.1869 10.4245 17.1148C10.3887 17.0427 10.3704 16.9632 10.3711 16.8826C10.3724 16.791 10.3949 16.7009 10.4369 16.6195L13.6422 10.0609C13.6887 9.96447 13.76 9.88207 13.8487 9.82212C13.9489 9.75601 14.0681 9.725 14.1878 9.73393C14.3074 9.74285 14.4207 9.79123 14.5099 9.87146C14.5743 9.92043 14.6261 9.98393 14.6612 10.0568C14.6963 10.1296 14.7137 10.2097 14.7119 10.2905C14.7106 10.3822 14.6881 10.4723 14.6461 10.5537L11.4468 17.1123C11.4023 17.2069 11.3344 17.2887 11.2494 17.3498C11.1626 17.4103 11.0592 17.4425 10.9533 17.4419ZM14.1356 10.0603C14.0975 10.0609 14.0604 10.0733 14.0297 10.0958C13.9889 10.1234 13.9562 10.1613 13.9349 10.2057L10.7303 16.7649C10.7112 16.8012 10.7008 16.8416 10.7001 16.8826C10.6991 16.9129 10.7058 16.9429 10.7195 16.9699C10.7332 16.9969 10.7534 17.0201 10.7784 17.0373C10.8948 17.1267 10.9862 17.132 11.0606 17.0794C11.1008 17.0507 11.133 17.0122 11.154 16.9675L14.3507 10.4083C14.3697 10.3719 14.3801 10.3316 14.381 10.2905C14.383 10.26 14.3774 10.2295 14.3645 10.2018C14.3516 10.1741 14.3319 10.1501 14.3073 10.132C14.2592 10.0903 14.199 10.0652 14.1356 10.0603Z"
                          fill="#EA6404"
                        ></path>
                        <path
                          d="M15.998 16.2202C15.9405 16.2175 15.8842 16.2023 15.8332 16.1756C15.7822 16.1489 15.7376 16.1113 15.7026 16.0656C15.6177 15.9806 15.5683 15.8665 15.5645 15.7465C15.5638 15.6908 15.5789 15.6361 15.6079 15.5886C15.6415 15.5368 15.6865 15.4934 15.7395 15.4616L18.4789 13.8748L18.5342 14.6642L15.748 12.9978C15.6911 12.9662 15.6452 12.918 15.6164 12.8596C15.5907 12.807 15.5772 12.7492 15.577 12.6906C15.5755 12.5659 15.6227 12.4455 15.7086 12.355C15.7398 12.3137 15.7793 12.2793 15.8247 12.2541C15.87 12.229 15.9201 12.2136 15.9717 12.209C16.0368 12.2107 16.1005 12.2283 16.1572 12.2603C16.2226 12.2945 16.2923 12.3327 16.3664 12.3748L18.9322 13.8827C18.9939 13.9184 19.0434 13.9718 19.0743 14.036C19.1055 14.1014 19.1217 14.173 19.1217 14.2455C19.1217 14.318 19.1055 14.3896 19.0743 14.455C19.0436 14.5195 18.9941 14.5732 18.9322 14.609L16.3664 16.0853C16.3007 16.1221 16.2349 16.1511 16.177 16.18C16.121 16.2065 16.0599 16.2202 15.998 16.2202Z"
                          fill="#EA6404"
                        ></path>
                        <path
                          d="M15.9985 16.3842C15.9178 16.3818 15.8386 16.3619 15.7663 16.3259C15.6941 16.2899 15.6305 16.2387 15.58 16.1757C15.468 16.0603 15.4039 15.9068 15.4004 15.7461C15.3993 15.6604 15.4221 15.5761 15.4662 15.5026C15.5124 15.43 15.5745 15.3688 15.6478 15.3237L17.5096 14.2447L15.6603 13.1395C15.5746 13.0919 15.5057 13.0191 15.4629 12.9309C15.4265 12.8561 15.4074 12.774 15.407 12.6908C15.4063 12.5245 15.47 12.3645 15.5846 12.2441C15.6572 12.1469 15.7631 12.08 15.8821 12.0563C16.001 12.0326 16.1245 12.0538 16.2287 12.1158C16.2945 12.1493 16.3669 12.1888 16.4432 12.2322L19.009 13.7408C19.099 13.7928 19.1712 13.8708 19.2162 13.9645C19.2588 14.0523 19.2812 14.1485 19.282 14.2461C19.2814 14.3432 19.2589 14.439 19.2162 14.5263C19.1714 14.6209 19.0986 14.6994 19.0077 14.7513L16.4471 16.2283C16.3715 16.2691 16.305 16.3026 16.2439 16.3303C16.167 16.3661 16.0832 16.3845 15.9985 16.3842ZM17.8333 14.4382L15.8208 15.6039C15.792 15.6218 15.7673 15.6455 15.7485 15.6737C15.7352 15.6955 15.7286 15.7206 15.7294 15.7461C15.7335 15.8254 15.7676 15.9001 15.8248 15.9553C15.9142 16.0553 15.9781 16.0553 15.9985 16.0553C16.0351 16.055 16.0713 16.0467 16.1044 16.0309C16.159 16.0059 16.2189 15.9763 16.2833 15.9408L18.355 14.7493L17.8333 14.4382ZM18.6445 13.9072L18.6906 14.5559L18.8458 14.4664C18.8794 14.4475 18.9061 14.4185 18.9221 14.3836C18.9427 14.3404 18.9534 14.2932 18.9534 14.2454C18.9534 14.1976 18.9427 14.1504 18.9221 14.1072C18.906 14.0726 18.8793 14.044 18.8458 14.0257L18.6445 13.9072ZM18.1596 14.2493L18.3471 14.3618L18.332 14.1487L18.1596 14.2493ZM15.9669 12.3737C15.9109 12.3875 15.8615 12.4205 15.8274 12.4671C15.7982 12.4965 15.7752 12.5314 15.7596 12.5698C15.744 12.6082 15.7362 12.6494 15.7366 12.6908C15.737 12.725 15.7451 12.7588 15.7603 12.7895C15.7753 12.8173 15.7982 12.8402 15.8261 12.8553L17.8333 14.0559L18.3682 13.7461L16.2761 12.5164C16.2057 12.4757 16.1379 12.4395 16.0741 12.4059C16.0413 12.387 16.0046 12.376 15.9669 12.3737Z"
                          fill="#EA6404"
                        ></path>
                      </svg>
                    </div>
                    <div className="file-text">
                      <span className="ext-name">{selectedfile?.name}</span>
                      <strong>
                      <span className="date-name"><DateFormat date={new Date()} format={null} timezone={null}/></span>
                        <span className="file-size">
                          {formatBytes(selectedfile?.size)}
                        </span>
                      </strong>
                    </div>
                  </div>
                  {fileSelection !==""?
                    <div onClick={()=>setSelectedFile("")} className="flex-right hover">
                    <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M8.20039 3.80078H11.8004C11.8004 3.32339 11.6107 2.86555 11.2732 2.52799C10.9356 2.19042 10.4778 2.00078 10.0004 2.00078C9.523 2.00078 9.06516 2.19042 8.7276 2.52799C8.39003 2.86555 8.20039 3.32339 8.20039 3.80078ZM7.00039 3.80078C7.00039 3.00513 7.31646 2.24207 7.87907 1.67946C8.44168 1.11685 9.20474 0.800781 10.0004 0.800781C10.796 0.800781 11.5591 1.11685 12.1217 1.67946C12.6843 2.24207 13.0004 3.00513 13.0004 3.80078H19.0004C19.1595 3.80078 19.3121 3.864 19.4247 3.97652C19.5372 4.08904 19.6004 4.24165 19.6004 4.40078C19.6004 4.55991 19.5372 4.71252 19.4247 4.82505C19.3121 4.93757 19.1595 5.00078 19.0004 5.00078H17.7356L16.3028 17.4136C16.2015 18.291 15.7812 19.1006 15.1218 19.6883C14.4625 20.2759 13.61 20.6007 12.7268 20.6008H7.27399C6.39074 20.6007 5.53833 20.2759 4.87895 19.6883C4.21958 19.1006 3.79927 18.291 3.69799 17.4136L2.26519 5.00078H1.00039C0.841261 5.00078 0.688648 4.93757 0.576127 4.82505C0.463605 4.71252 0.400391 4.55991 0.400391 4.40078C0.400391 4.24165 0.463605 4.08904 0.576127 3.97652C0.688648 3.864 0.841261 3.80078 1.00039 3.80078H7.00039ZM4.88959 17.2768C4.9573 17.8617 5.23765 18.4012 5.67729 18.7929C6.11694 19.1845 6.68521 19.4009 7.27399 19.4008H12.7268C13.3156 19.4009 13.8838 19.1845 14.3235 18.7929C14.7631 18.4012 15.0435 17.8617 15.1112 17.2768L16.5272 5.00078H3.47359L4.88959 17.2768ZM8.20039 8.00078C8.35952 8.00078 8.51213 8.06399 8.62466 8.17652C8.73718 8.28904 8.80039 8.44165 8.80039 8.60078V15.8008C8.80039 15.9599 8.73718 16.1125 8.62466 16.225C8.51213 16.3376 8.35952 16.4008 8.20039 16.4008C8.04126 16.4008 7.88865 16.3376 7.77613 16.225C7.6636 16.1125 7.60039 15.9599 7.60039 15.8008V8.60078C7.60039 8.44165 7.6636 8.28904 7.77613 8.17652C7.88865 8.06399 8.04126 8.00078 8.20039 8.00078ZM12.4004 8.60078C12.4004 8.44165 12.3372 8.28904 12.2247 8.17652C12.1121 8.06399 11.9595 8.00078 11.8004 8.00078C11.6413 8.00078 11.4886 8.06399 11.3761 8.17652C11.2636 8.28904 11.2004 8.44165 11.2004 8.60078V15.8008C11.2004 15.9599 11.2636 16.1125 11.3761 16.225C11.4886 16.3376 11.6413 16.4008 11.8004 16.4008C11.9595 16.4008 12.1121 16.3376 12.2247 16.225C12.3372 16.1125 12.4004 15.9599 12.4004 15.8008V8.60078Z"
                fill="#6D7080"
              ></path>
            </svg>
                    </div>:Constants.BLANK}
                </div>
                <div className={showProgress ? "right-progressbar" : "right-progressbar hide"}>
                  <CustomProgressBar
                  completed={fileUploadProgress}
                  labelLineHeight="1px"
                  labelSize="14px"
                  width="100%"
                  labelClassName="progressBarLabel"
                  borderRadius = "30px"
                  labelAlignment="outside"
                  labelColor="rgba(0,0,0,0.87)"
                  height="10px"
                  className="file_upload_progress"
                  bgColor="#06B878"
                  baseBgColor="#D1DEF0"
                  ariaValuetext={fileUploadProgress}
                  aria-label=""
                  aria-valuenow={fileUploadProgress}
                />
                </div>
              </div>
        </div>
      </div>
      <div className="form-group">
        <h6 className="subhead-taskform">
          {translate("task_campaign.task_dates")} <span>{translate("task_campaign.optional")}</span>
        </h6>
        <div className="flex wrap-dropdown flex-basline">
          <div className="global-dropdown-block flex-center firstCal">
            <label>  {translate("task_campaign.start_date")}</label>
            <div className="global-dropdown-select">
              <button
                onClick={(e) => {
                  showCalendarStartDate(e);
                }}
                onKeyDown={(e) => handleEscFocus(e)}
                id='calFirstFocus'
                ref={refToggle}
                tabIndex={0}
                type="button"
                className="drop-down-btn gb-dropBtn"
                aria-expanded={toggle ? 'true':'false'}
                aria-label={toggle ? 'choose date dialog': startDate !== "" ? `start date ${dateUtil.format(startDate,null,null)} selected` :""}
              >
                <span>{startDate !== ""? dateUtil.format(startDate,null,null) :""}</span>
                <span className="font-zero">{startDate !== ""? dateUtil.format(startDate,null,null) :"Task Start Date"}</span>
                <svg
                  aria-hidden="true"
                  className="calender-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z"
                    fill="#3564EB"
                  />
                </svg>
              </button>
            </div>
            {toggle ? (
              <div
                ref={refCalendar}
                onKeyDown={(e) => {
                  closeCalendar(e);
                }}
              >
                <DatePickerCalendar
                 defaultValue={ new Date()}
                 className="dashCalendar"
                 minDate={new Date()}
                 selectDate={selectStartDate}
                />
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="global-dropdown-block flex-center caltopset">
            <label> {translate("task_campaign.due_date")}</label>
            
             <div className="global-dropdown-select">
              <button
                onClick={(e) => {
                  showCalendarDueDate(e);
                }}
                onFocus={()=>toggleCal(false)}
                onKeyDown={(e) => handleEscFocus2(e)}
                ref={refToggle1}
                id='calSecondFocus'
                tabIndex={0}
                type="button"
                className="drop-down-btn gb-dropBtn"
                aria-expanded={toggle1 ? 'true':'false'}
                aria-label={toggle1 ? 'choose date dialog' : dueDate !== "" ? dateUtil.format(dueDate, null, null) : ""}
              >
                <span>{dueDate !== "" ? dateUtil.format(dueDate, null, null) : ""}</span>
                <span className="font-zero">{dueDate !== "" ? `due date ${dateUtil.format(dueDate, null, null)} selected` : "Due Date"}</span>
                <svg
                  aria-hidden="true"
                  className="calender-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z"
                    fill="#3564EB"
                  />
                </svg>
              </button>
            </div>
            {toggle1 ? (
              <div
                ref={refCalendar1}
                onKeyDown={(e) => {
                  closeCalendar2(e);
                }}
              >
                <DatePickerCalendar
                  value={new Date()}
                  className="dashCalendar1"
                  minDate={new Date(addDaysToDate(startDate, 1, ""))}
                  selectDate={selectDueDate}
                />
              </div>
            ) : (
              ""
            )}
            <div className="form-check-outer">
              <div className="form-check small-checkbox">
                <input
                  type="checkbox"
                  id="Remind Assignee"
                  disabled={dueDate === "" ? true : false}
                  onChange={setReminder}
                />
                <label htmlFor="Remind Assignee">{translate("task_campaign.remind_assignee")}</label>
              </div>
              <div className="form-number flex-center">
                <input
                  type="text"
                  id="emailReminderDay"
                  name="emailReminderDay"
                  maxLength={2}
                  className="form-control-sm"
                  disabled={!allowReminder}
                  onChange={handleReminderDay}
                />
                <label htmlFor="Days before due date">
                {translate("task_campaign.days_before_due_date")}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end btn-gap">
          <button
            className={
              taskName === "" || selectedAssignedUser === ""
                ? "disabled-data btn btn-bold"
                : "btn btn-bold"
            }
            onClick={createTask}
           // disabled={taskName === "" || selectedAssignedUser === ""}
          >
            {translate("task_campaign.create_task")}
          </button>
          <button className="btn btn-bold" onClick={resetfelds}>
           {translate("task_campaign.cancel")}
          </button>
        </div>
      </div>
    </div>
  );
}
